export class Conflict extends Error {

}

function getErrorText (props) {
  let error = `CONFLICT! @ ${props.path}\nRepo: ${props.repo}\nYours: ${props.yours}\nTheirs: ${props.theirs}\n`;
  if (props.message) {
    error += `Message:${props.message}`;
  }
  return error;
}

export class ContentConflict extends Conflict {
  constructor (props) {
    if (typeof props === 'string') {
      super(props);
    } else {
      super(getErrorText(props));
    }
  }
}

export class DeletedContentConflict extends ContentConflict {
  constructor (props) {
    super('DELETED ' + getErrorText(props));
  }

}

DeletedContentConflict.Deleted = {toString () {return '<deleted>'}};



// WEBPACK FOOTER //
// ./lib/rlink-repos/conflict.js